module.exports = __webpack_public_path__ + "static/media/app_store_rating.4c3b4607.jpg";